
import { useAppStore } from "@/lib/store";
import Hero from "@/components/home/Hero";
import CategoryMultiverse from "@/components/home/CategoryMultiverse";
import ProductRail from "@/components/home/ProductRail";
import RareFinds from "@/components/home/RareFinds";
import SellSection from "@/components/home/SellSection";
import { useDocumentMeta } from "@/lib/useDocumentMeta";

export default function Home() {
  useDocumentMeta({
    title: "Nerd Multiverse",
    description:
      "Discover second-hand collectibles, figures, comics, gaming gear, anime treasures and memorabilia from sellers across the Nerd Multiverse.",
    path: "/",
  });

  const products = useAppStore((s) => s.products);
  const approved = products.filter((p) => p.status === "approved");

  const newArrivals = [...approved]
    .sort((a, b) => b.createdAt - a.createdAt)
    .slice(0, 10);
  const rareFinds = approved.filter((p) => p.isRareFind).slice(0, 5);
  const underTwenty = approved.filter((p) => p.price < 20).slice(0, 10);

  return (
    <>
      <Hero />
      <ProductRail
        title="New to the Multiverse"
        subtitle="Just landed from sellers across the network."
        products={newArrivals}
      />
      <CategoryMultiverse />
      <RareFinds products={rareFinds} />
      <ProductRail
        title="Under £20"
        subtitle="Great finds that won't break the bank."
        products={underTwenty}
      />
      <SellSection />
    </>
  );
}
